import script from "./ContainerHomePosts.vue?vue&type=script&setup=true&lang=js"
export * from "./ContainerHomePosts.vue?vue&type=script&setup=true&lang=js"

import "./ContainerHomePosts.vue?vue&type=style&index=0&id=249a59d4&lang=scss&scoped=true"
import "./ContainerHomePosts.vue?vue&type=style&index=1&id=249a59d4&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-249a59d4"]])

export default __exports__